var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9735 9.29776C15.5766 9.29776 16.875 10.5743 16.875 12.1493C16.875 13.7234 15.5766 15 13.9735 15C12.3713 15 11.0719 13.7234 11.0719 12.1493C11.0719 10.5743 12.3713 9.29776 13.9735 9.29776ZM6.82027 10.9333C7.52246 10.9333 8.09245 11.4933 8.09245 12.1831C8.09245 12.8721 7.52246 13.433 6.82027 13.433H1.27218C0.569997 13.433 0 12.8721 0 12.1831C0 11.4933 0.569997 10.9333 1.27218 10.9333H6.82027ZM2.90155 0C4.50466 0 5.80309 1.27658 5.80309 2.85066C5.80309 4.42566 4.50466 5.70224 2.90155 5.70224C1.29937 5.70224 0 4.42566 0 2.85066C0 1.27658 1.29937 0 2.90155 0ZM15.6038 1.60171C16.305 1.60171 16.875 2.16171 16.875 2.85066C16.875 3.54053 16.305 4.10053 15.6038 4.10053H10.0557C9.35348 4.10053 8.78348 3.54053 8.78348 2.85066C8.78348 2.16171 9.35348 1.60171 10.0557 1.60171H15.6038Z",
    fill: "#9EA7AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a9a6af8d96ca6fea8775e27805c0d91d.svg";
export { ForwardRef as ReactComponent };